import { InterpolationAlgo } from "../helpers";

// Desired flow rate - q_l? stbd
// Produced flow rate - Q_l? stbd
// Avg res pressure - P_r psia
// Well flowing pressure - P_wf psia
// Water cut - WCut %
// returns P_wf psia
export function getWellFlowingPressureUsingWiggins(
  desired_flow_rate: number,
  produced_flow_rate: number,
  average_reservoir_pressure: number,
  well_flowing_pressure: number,
  water_cut: number
): number {
  const number_of_pts = 11;
  const linear_coefficient = 0.48;
  const quadratic_coefficient = 0.52;
  const flowing_pressure = well_flowing_pressure;
  const static_pressure = average_reservoir_pressure;

  const PI_water =
    (produced_flow_rate * water_cut) / (static_pressure - flowing_pressure);
  const test_oil_rate = produced_flow_rate * (1 - water_cut);

  const test_PRATIO = flowing_pressure / static_pressure;
  const absolute_open_flow_oil =
    test_oil_rate /
    (1 -
      quadratic_coefficient * test_PRATIO -
      linear_coefficient * Math.pow(test_PRATIO, 2));

  const QL = [];
  const FBPHP = [];
  let QO_value = 0;
  for (let i = 0; i < number_of_pts; i++) {
    if (i === 0) {
      QO_value = 0;
    } else {
      QO_value = QO_value + absolute_open_flow_oil / (number_of_pts - 1);
    }
    const C_value = QO_value / absolute_open_flow_oil - 1;
    const PRATIO_value =
      (-quadratic_coefficient +
        Math.sqrt(
          Math.pow(quadratic_coefficient, 2) - 4 * linear_coefficient * C_value
        )) /
      (2 * linear_coefficient);
    const FBHP_value = static_pressure * PRATIO_value;
    const QW_value = (static_pressure - FBHP_value) * PI_water;
    const QL_value = QO_value + QW_value;
    FBPHP.push(FBHP_value);
    QL.push(QL_value);
  }
  const calc_pwd_value = InterpolationAlgo(
    QL,
    FBPHP,
    desired_flow_rate,
    2,
    QL.length
  );
  return calc_pwd_value;
}
